<template>
  <div>
    <TheTimeline class="mt-5"></TheTimeline>
    <v-container fluid>
      <!-- ACTIONS CARDS -->
      <ActionsCardsSportips class="my-2" v-if="mainStore.authAdmin.isSportipsAdmin"></ActionsCardsSportips>
      <ActionsCards class="my-2"></ActionsCards>

      <!-- PANELS D'INFOS DU MODULE -->
      <v-expansion-panels multiple class="mt-4">
        <v-expansion-panel key="accueil" v-if="mainStore.module.has_accueil_qr_code">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Accueil des participants</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <AccueilSection class="my-2"></AccueilSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="parcours">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Les parcours</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <ParcoursSection class="my-2"></ParcoursSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="options">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Les options</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <OptionsSection class="my-2"></OptionsSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="activites">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Les activités</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <ActivitesSection class="my-2"></ActivitesSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="activites">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">La boutique</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <ArticlesSection class="my-2"></ArticlesSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="tshirts">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Les Tee-shirts</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <TeeShirtSection class="my-2"></TeeShirtSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="finances">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Les finances</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <FinancesSection class="my-2"></FinancesSection>
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel key="historique">
          <v-expansion-panel-title>
            <div class="text-h4 font-weight-bold my-2 text-darkblue">Historique des éditions</div>
            <template v-slot:actions="{ expanded }">
              <v-btn size="small" color="primary-dark" variant="elevated"><v-icon size="large"
                  :icon="expanded ? 'mdi-minus' : 'mdi-plus'"></v-icon></v-btn>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <HistoriqueSection class="my-2"></HistoriqueSection>
          </v-expansion-panel-text>
        </v-expansion-panel>

      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TheTimeline from "@/components/Administration/Dashboard/TheTimeline.vue";
import ActionsCards from "@/components/Administration/Dashboard/Actions_Cards/ActionsCards.vue";
import ActionsCardsSportips from "@/components/Administration/Dashboard/Actions_Cards/ActionsCardsSportips.vue";
import ParcoursSection from "@/components/Administration/Dashboard/Parcours/ParcoursSection.vue";
import OptionsSection from "@/components/Administration/Dashboard/Options/OptionsSection.vue";
import ActivitesSection from "@/components/Administration/Dashboard/Activites/ActivitesSection.vue";
import ArticlesSection from "@/components/Administration/Dashboard/Articles/ArticlesSection.vue";
import TeeShirtSection from "@/components/Administration/Dashboard/TeeShirt/TeeShirtSection.vue";
import FinancesSection from "@/components/Administration/Dashboard/Finances/FinancesSection.vue";
import AccueilSection from "@/components/Administration/Dashboard/Accueil/AccueilSection.vue";
import HistoriqueSection from "@/components/Administration/Dashboard/Historique/HistoriqueSection.vue";


export default {
  components: { TheTimeline, ActionsCards, ActionsCardsSportips, ParcoursSection, OptionsSection, ActivitesSection, ArticlesSection, FinancesSection, TeeShirtSection, AccueilSection, HistoriqueSection },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>